module.exports = __webpack_public_path__ + "static/media/engineering.29229d7c.jpg";